// Elasticsearch begrenzt from + size beim normalen Search auf index.max_result_window
// (Default 10'000). page/pageSize aus der URL müssen deshalb so geklemmt werden, dass
// (page + 1) * pageSize dieses Limit nie überschreitet, sonst antwortet das
// hub-search-backend mit 400 "Die angeforderte Seite liegt ausserhalb des durchsuchbaren
// Bereichs." (WEB-3969). Das Backend klemmt mit derselben Grenze.
export const MAX_SEARCH_RESULT_WINDOW = 10000;

export function clampSearchPaging(page: number, pageSize: number): { page: number; pageSize: number } {
  const safePageSize = Number.isFinite(pageSize) ? Math.trunc(pageSize) : 1;
  const safePage = Number.isFinite(page) ? Math.trunc(page) : 0;
  const clampedPageSize = Math.min(Math.max(safePageSize, 1), MAX_SEARCH_RESULT_WINDOW);
  const maxPage = Math.floor(MAX_SEARCH_RESULT_WINDOW / clampedPageSize) - 1;
  const clampedPage = Math.min(Math.max(safePage, 0), maxPage);
  return { page: clampedPage, pageSize: clampedPageSize };
}

export function maxReachablePageCount(pageSize: number): number {
  const safePageSize = Number.isFinite(pageSize) ? Math.trunc(pageSize) : 1;
  return Math.max(Math.floor(MAX_SEARCH_RESULT_WINDOW / Math.max(safePageSize, 1)), 1);
}
